import { ParsedUrlQuery } from 'querystring';

export function getIsRetirementHome(query: ParsedUrlQuery) {
    if (query['is_retirement_home']) {
        return query['is_retirement_home'];
    }

    if (query['search-path']?.[0] === 'retirement') {
        return 'true';
    }

    return '';
}
